<div class="detalhe-solicitacao">
  @if (naoEncontrada()) {
    <div class="detalhe-solicitacao__empty" role="alert" data-testid="detalhe-solicitacao-nao-encontrada">
      <p class="detalhe-solicitacao__empty-message">Solicitação não encontrada.</p>
      <vivest-button variant="primary" size="md" data-testid="sem-dados-voltar" (click)="voltar()">
        Voltar
      </vivest-button>
    </div>
  } @else if (solicitacao(); as solicitacao) {
    <!-- Título com o status ao lado e, embaixo, o resumo da solicitação; Voltar à direita. -->
    <header class="detalhe-solicitacao__header">
      <div class="detalhe-solicitacao__titulo-bloco">
        <div class="detalhe-solicitacao__titulo-linha">
          <h1 id="detalhe-solicitacao-title" class="detalhe-solicitacao__title" data-testid="detalhe-solicitacao-nome">
            Detalhes da Solicitação
          </h1>
          <app-instituto-status-tag [status]="statusAtual()" data-testid="detalhe-solicitacao-status" />
        </div>
        <p class="detalhe-solicitacao__resumo" data-testid="detalhe-solicitacao-resumo">
          <span>Protocolo nº {{ solicitacao.protocolo ?? '—' }}</span>
          @if (solicitacao.ultimaAtualizacao) {
            <span>Última atualização em {{ formatDate(solicitacao.ultimaAtualizacao) }}</span>
          }
        </p>
      </div>
      <vivest-button variant="outline" size="sm" data-testid="detalhe-solicitacao-voltar" (click)="voltar()">
        <vivest-icon slot="icon-left" name="arrow-left" source="feather"></vivest-icon>
        Voltar
      </vivest-button>
    </header>

    <!-- Dados e documentos à esquerda; histórico à direita (empilham em telas estreitas). -->
    <div class="detalhe-solicitacao__conteudo">
      <div class="detalhe-solicitacao__principal">
        <section aria-labelledby="dados-titulo">
          <vivest-card variant="default" full-width data-testid="detalhes-painel">
            <div class="detalhe-solicitacao__card">
              <h2 id="dados-titulo" class="page-section-title">Dados da solicitação</h2>
              <dl class="detalhe-solicitacao__fields">
                <div class="detalhe-solicitacao__field detalhe-solicitacao__field--inteiro">
                  <dt class="detalhe-solicitacao__label">Participante</dt>
                  <dd class="detalhe-solicitacao__value detalhe-solicitacao__value--destaque">{{ solicitacao.nomeParticipante || '—' }}</dd>
                </div>
                <div class="detalhe-solicitacao__field">
                  <dt class="detalhe-solicitacao__label">Matrícula</dt>
                  <dd class="detalhe-solicitacao__value" data-testid="detalhe-solicitacao-matricula">
                    {{ solicitacao.matricula ?? '—' }}
                  </dd>
                </div>
                <div class="detalhe-solicitacao__field">
                  <dt class="detalhe-solicitacao__label">Nº Protocolo de Solicitação</dt>
                  <dd class="detalhe-solicitacao__value" data-testid="detalhe-solicitacao-protocolo">
                    {{ solicitacao.protocolo ?? '—' }}
                  </dd>
                </div>
                <div class="detalhe-solicitacao__field">
                  <dt class="detalhe-solicitacao__label">Plano</dt>
                  <dd class="detalhe-solicitacao__value" data-testid="detalhe-solicitacao-plano">
                    {{ planoLabel(solicitacao.plano) }}
                  </dd>
                </div>
                <div class="detalhe-solicitacao__field">
                  <dt class="detalhe-solicitacao__label">Tipo de Instituto</dt>
                  <dd class="detalhe-solicitacao__value" data-testid="detalhe-solicitacao-instituto">
                    {{ solicitacao.tipoInstituto ?? '—' }}
                  </dd>
                </div>
                <div class="detalhe-solicitacao__field">
                  <dt class="detalhe-solicitacao__label">Data e hora da Solicitação</dt>
                  <dd class="detalhe-solicitacao__value" data-testid="detalhe-solicitacao-data">
                    {{ solicitacao.dataSolicitacao ? dataHora(solicitacao.dataSolicitacao) : '—' }}
                  </dd>
                </div>
                <div class="detalhe-solicitacao__field">
                  <dt class="detalhe-solicitacao__label">Elegível à Retenção</dt>
                  <dd class="detalhe-solicitacao__value" data-testid="detalhe-solicitacao-elegivel">
                    {{ solicitacao.elegivelRetencao == null ? '—' : solicitacao.elegivelRetencao ? 'Sim' : 'Não' }}
                  </dd>
                </div>
              </dl>
            </div>
          </vivest-card>
        </section>

        <!-- Em retenção o participante ainda não envia documentos: a seção não aparece. -->
        @if (mostrarDocumentos()) {
          <section aria-labelledby="documentacao-titulo">
            <vivest-card variant="default" full-width data-testid="documentos-painel">
              <div class="documentos">
                <h2 id="documentacao-titulo" class="page-section-title">
                  Documentação anexada
                  @if (documentos().length > 0) {
                    <span class="documentos__contagem" data-testid="documentos-contagem">{{ documentos().length }}</span>
                  }
                </h2>
  
                @if (documentos().length === 0) {
                  <p class="documentos__vazio" data-testid="documentos-vazio">
                    Não há documentação anexada pelo participante neste momento do processo.
                  </p>
                } @else {
                  <!-- Cada documento é um link de download do arquivo enviado pelo participante. -->
                  <ul class="documentos__lista">
                    @for (documento of documentos(); track documento.nomeArquivo) {
                      <!-- O cartão inteiro baixa o arquivo; o olho, por cima do cartão, abre o PDF em outra aba. -->
                      <li
                        class="documentos__item"
                        [class.documentos__item--reenviado]="reenviado(documento)"
                        [class.documentos__item--rejeitado]="rejeitado(documento)"
                        [attr.data-testid]="reenviado(documento) ? 'documento-reenviado' : rejeitado(documento) ? 'documento-rejeitado' : null"
                      >
                        <a
                          class="documentos__arquivo"
                          [href]="documento.link"
                          [attr.download]="documento.nomeArquivo"
                          target="_blank"
                          rel="noopener"
                          [attr.aria-label]="'Baixar ' + documento.tipoDocumento + ' (' + documento.nomeArquivo + ')'"
                          data-testid="documento-link"
                        >
                          <img class="documentos__icone" src="assets/images/Documento.svg" alt="" />
                          <span class="documentos__info">
                            <span class="documentos__tipo">
                              {{ documento.tipoDocumento }}
                              @if (reenviado(documento)) {
                                <span class="documentos__selo">Reenviado para análise</span>
                              } @else if (rejeitado(documento)) {
                                <span class="documentos__selo documentos__selo--rejeitado">Rejeitado</span>
                              }
                            </span>
                            <span class="documentos__nome">{{ documento.nomeArquivo }}</span>
                            @if (reenviado(documento)) {
                              <span class="documentos__reenvio">Reenviado em {{ dataHora(documento.enviadoEm) }}</span>
                            } @else if (rejeitado(documento)) {
                              @if (rejeicao(documento); as avaliacao) {
                                <span class="documentos__reenvio documentos__reenvio--rejeitado">
                                  Rejeitado em {{ dataHora(avaliacao.avaliadoEm) }} por {{ avaliacao.avaliadoPor }}
                                </span>
                                <span class="documentos__motivo" data-testid="documento-motivo">Motivo: {{ avaliacao.motivo }}</span>
                              } @else {
                                <span class="documentos__reenvio documentos__reenvio--rejeitado">Aguardando reenvio do participante</span>
                              }
                            } @else {
                              <span class="documentos__dica">Clique para baixar o documento</span>
                            }
                          </span>
                          <vivest-icon class="documentos__download" name="download" source="feather" aria-hidden="true"></vivest-icon>
                        </a>
                        <button
                          type="button"
                          class="documentos__visualizar"
                          title="Visualizar PDF"
                          [attr.aria-label]="'Visualizar ' + documento.tipoDocumento + ' (' + documento.nomeArquivo + ')'"
                          data-testid="documento-visualizar"
                          (click)="abrirVisualizacao(documento)"
                        >
                          <vivest-icon name="eye" source="feather" aria-hidden="true"></vivest-icon>
                        </button>
                      </li>
                    }
                  </ul>
  
                  <!-- Aviso em destaque, com `podeAvaliarDocs`: orientação à esquerda, ações à direita. -->
                  @if (podeValidarDocumentos()) {
                    <div class="documentos__acao" role="group" aria-labelledby="documentos-acao-titulo">
                      <div class="documentos__acao-texto">
                        <h3 id="documentos-acao-titulo" class="documentos__acao-titulo">
                          <vivest-icon name="alert-circle" source="feather" aria-hidden="true"></vivest-icon>
                          Ação necessária
                        </h3>
                        <p class="documentos__acao-descricao" data-testid="documentos-acao-descricao">
                          @if (documentosReenviados().length) {
                            O participante reenviou <strong>{{ nomesReenviados() }}</strong>. Confira o que foi reenviado: aprove se
                            estiver correto ou peça o reenvio de novo.
                          } @else if (documentoUnico()) {
                            Confira o documento enviado pelo participante. Aprove se estiver correto ou peça o reenvio.
                          } @else {
                            Confira os documentos enviados pelo participante. Aprove se estiverem corretos ou peça o reenvio dos que tiverem problema.
                          }
                        </p>
                      </div>
                      <div class="documentos__botoes">
                        <vivest-button variant="outline" size="md" data-testid="documentos-reenvio" (click)="abrirReenvio()">
                          {{ documentoUnico() ? 'Solicitar reenvio do documento' : 'Solicitar reenvio de documentos' }}
                        </vivest-button>
                        <vivest-button variant="primary" size="md" data-testid="documentos-aprovar" (click)="abrirConfirmacao()">
                          {{ documentoUnico() ? 'Aprovar Documento' : 'Aprovar Documentos' }}
                        </vivest-button>
                      </div>
                    </div>
                  }
                }
              </div>
            </vivest-card>
          </section>
        }
      </div>

      <section class="detalhe-solicitacao__lateral" aria-labelledby="historico-titulo">
        <vivest-card variant="default" full-width data-testid="historico-painel">
          <div class="historico">
            <h2 id="historico-titulo" class="page-section-title">Histórico da solicitação</h2>
            @if (historico().length === 0) {
              <p class="historico__vazio" data-testid="historico-vazio">Nenhuma movimentação registrada.</p>
            } @else {
              <!-- Mais recente primeiro: cada item é uma mudança de status. -->
              <ol class="historico__lista">
                @for (item of historico(); track item.idHistorico) {
                  <li class="historico__item" data-testid="historico-item">
                    <span class="historico__marcador" aria-hidden="true"></span>
                    <div class="historico__conteudo">
                      <app-instituto-status-tag [status]="item.statusUnificado" data-testid="historico-status" />
                      <p class="historico__meta">
                        @if (item.alteradoEm) {
                          <span>{{ dataHora(item.alteradoEm) }}</span>
                        }
                        @if (item.alteradoPor) {
                          <span>por {{ item.alteradoPor }}</span>
                        }
                      </p>
                      @if (item.statusAnterior) {
                        <p class="historico__anterior">Status anterior: {{ statusDetalheLabel(item.statusAnterior) }}</p>
                      }
                      @if (item.observacao) {
                        <p class="historico__observacao">{{ item.observacao }}</p>
                      }
                    </div>
                  </li>
                }
              </ol>
            }
          </div>
        </vivest-card>
      </section>
    </div>
  }
</div>

<vivest-modal
  heading="Você tem certeza?"
  [hasIcon]="false"
  [open]="confirmacaoAberta()"
  position="center"
  (vivest-close)="fecharConfirmacao()"
  data-testid="modal-aprovar"
>
  <!-- O vivest-modal só exibe conteúdo nos slots icon, heading, description e actions. -->
  <div slot="description">
    <p class="mb-0 text-start">Você está prestes a aprovar todos os documentos. Depois de confirmada, essa ação não poderá ser desfeita. Deseja continuar?</p>
  </div>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="modal-aprovar-cancelar" (click)="fecharConfirmacao()">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="modal-aprovar-confirmar" (click)="aprovar()">
    Aprovar
  </vivest-button>
</vivest-modal>

<vivest-modal
  [heading]="documentoUnico() ? 'Solicitar reenvio do documento' : 'Solicitar reenvio de documentos'"
  [hasIcon]="false"
  [open]="reenvioAberto()"
  position="center"
  (vivest-close)="fecharReenvio()"
  data-testid="modal-reenvio"
>
  <form slot="description" class="reenvio" novalidate [formGroup]="reenvioForm" (submit)="$event.preventDefault(); enviarReenvio()">
    <p class="reenvio__texto">
      Selecione os documentos que precisam ser reenviados pelo titular e informe o motivo nos comentários abaixo.
    </p>

    <fieldset class="reenvio__documentos">
      <legend class="detalhe-form-label">Documentos<span class="detalhe-form-required" aria-hidden="true">*</span></legend>
      @for (documento of documentos(); track documento.idDocumento) {
        <vivest-checkbox
          label-variant="multi-line"
          name="documentos-reenvio"
          [value]="documento.idDocumento"
          [checked]="documentoSelecionado(documento.idDocumento)"
          (change)="alternarDocumento(documento.idDocumento, $any($event.target).checked)"
          [attr.data-testid]="'reenvio-documento-' + $index"
        >
          {{ documento.tipoDocumento }}
        </vivest-checkbox>
      }
      @if (reenvioForm.controls.documentos.touched && reenvioForm.controls.documentos.invalid) {
        <p class="detalhe-form-error" role="alert" data-testid="reenvio-documentos-erro">
          Selecione ao menos um documento.
        </p>
      }
    </fieldset>

    <div class="reenvio__comentario">
      <label class="detalhe-form-label" for="reenvio-comentarios">Comentários<span class="detalhe-form-required" aria-hidden="true">*</span></label>
      <textarea
        id="reenvio-comentarios"
        class="form-control detalhe-form-control detalhe-form-textarea"
        rows="3"
        placeholder="Adicione aqui seu comentário"
        [attr.maxlength]="comentarioMaximo"
        formControlName="comentarios"
        required
        aria-required="true"
        [class.is-invalid]="!!erroComentario()"
        aria-describedby="reenvio-comentarios-contador"
        data-testid="reenvio-comentarios"
      ></textarea>
      <p id="reenvio-comentarios-contador" class="reenvio__contador">
        {{ reenvioForm.controls.comentarios.value.length }}/{{ comentarioMaximo }}
      </p>
      @if (erroComentario(); as mensagem) {
        <p class="detalhe-form-error" role="alert" data-testid="reenvio-comentarios-erro">{{ mensagem }}</p>
      }
    </div>
  </form>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="modal-reenvio-cancelar" (click)="fecharReenvio()">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="modal-reenvio-enviar" (click)="enviarReenvio()">
    Enviar para o participante
  </vivest-button>
</vivest-modal>

<!-- O iframe só existe com o modal aberto: o PDF não é carregado à toa. -->
<vivest-modal
  class="visualizador-modal"
  style="--vivest-modal-width: 951px;"
  [heading]="documentoVisualizado()?.tipoDocumento ?? ''"
  [hasIcon]="false"
  [open]="!!documentoVisualizado()"
  position="center"
  (vivest-close)="fecharVisualizacao()"
  data-testid="modal-visualizar-documento"
>
  @if (documentoVisualizado(); as documento) {
    <div slot="description" class="visualizador">
      <!-- Arquivo à esquerda; abrir fora do modal e baixar à direita, sem precisar fechar. -->
      <div class="visualizador__barra">
        <span class="visualizador__arquivo">
          <img class="visualizador__icone" src="assets/images/Documento.svg" alt="" />
          <span class="visualizador__nome" data-testid="visualizador-nome">{{ documento.nomeArquivo }}</span>
        </span>
        <span class="visualizador__acoes">
          <a
            class="visualizador__acao"
            [href]="documento.link"
            target="_blank"
            rel="noopener"
            data-testid="visualizador-nova-aba"
          >
            <vivest-icon name="external-link" source="feather" aria-hidden="true"></vivest-icon>
            Abrir em nova aba
          </a>
          <a
            class="visualizador__acao"
            [href]="documento.link"
            [attr.download]="documento.nomeArquivo"
            data-testid="visualizador-baixar"
          >
            <vivest-icon name="download" source="feather" aria-hidden="true"></vivest-icon>
            Baixar
          </a>
        </span>
      </div>
      <iframe
        class="visualizador__pdf"
        [src]="urlVisualizacao()"
        [title]="'Visualização de ' + documento.tipoDocumento"
        data-testid="visualizador-pdf"
      ></iframe>
    </div>
  }
  <vivest-button slot="actions" variant="primary" size="md" data-testid="modal-visualizar-fechar" (click)="fecharVisualizacao()">
    Fechar
  </vivest-button>
</vivest-modal>